import { lazy, Suspense, type ComponentProps } from "react";
import type { QRCodeSVG as QRCodeSVGType } from "qrcode.react";

type DeferredQRCodeProps = ComponentProps<typeof QRCodeSVGType>;

const QRCodeSVG = lazy(async () => {
  const module = await import("qrcode.react");
  return { default: module.QRCodeSVG };
});

export function DeferredQRCode(props: DeferredQRCodeProps) {
  const size = typeof props.size === "number" ? props.size : 128;
  return (
    <Suspense fallback={<span className="deferred-qr-placeholder" style={{ width: size, height: size }} aria-hidden="true" />}>
      <QRCodeSVG {...props} />
    </Suspense>
  );
}
